import {
  Modal,
  Card,
  CardContent,
  Typography,
  Stack,
  Button,
} from "@mui/material";

interface Props {
  openModal: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmPaymentConditionChangeModal = (props: Props) => {
  return (
    <Modal
      open={props.openModal}
      onClose={props.onCancel}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card
        sx={{
          height: "30vh",
          width: { md: "40%", xs: "70%" },
        }}
      >
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h6">Trocar condição de pagamento?</Typography>
            <Typography variant="body2">
              Ao trocar a condição de pagamento, os descontos do pedido serão
              removidos. Deseja continuar?
            </Typography>
            <Stack direction={"row"} justifyContent={"space-around"}>
              <Button
                variant="outlined"
                color="success"
                onClick={props.onConfirm}
              >
                Confirmar
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={props.onCancel}
              >
                Cancelar
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default ConfirmPaymentConditionChangeModal;
